export const Constants = {
    API_URL: 'https://carron-lodge-warehouse.test/api',
    REVERB_HOST: 'reverb.herd.test',
    REVERB_PORT: 443,
    REVERB_APP_ID: '1001',
    REVERB_APP_KEY: 'laravel-herd',
    REVERB_APP_SECRET: 'secret',
};